

import Intro from "../../components/intro/Intro.jsx";
import admInt from "../../images/admininterface.png";
import prodInt from "../../images/prodinterface.png";
import developInt from "../../images/developerinterface.png";
import "./MainPage.scss";
import Advantages from "shared/components/Advantages";
import blueIcon from "../../images/icons/station.svg";
import darkBlueIcon from "../../images/icons/industry.svg";
import yellowIcon from "../../images/icons/Min-industry.svg";
import AutomationSection from "shared/components/AutomationSection";
import { AppRoute } from "../../constants.jsx";
import { ExpertAutomatizationAdd } from "../../components/ExpertAutomatizationAdd.jsx";
import { BackgroundSection } from "shared/components/BackgroundSection";
import Layout from "../../components/Layout.jsx";


const automationColumns = [
  {
    title: "Электроэнергетика",
    paragraph:
      "Автоматизация технологических процессов, связанных с генерацией, передачей, распределением и потреблением электроэнергии",
    color: "rgb(41 117 219)",
    image: blueIcon,
    link: AppRoute.ElectricPower,
  },
  {
    title: "Добывающая промышленность",
    paragraph:
      "Автоматизация технологических процессов, связанных с добычей и транспортировкой сырья и топлива",
    color: "#F4D1AA",
    image: yellowIcon,
    link: AppRoute.MiningIndustry,
  },
  {
    title: "Обрабатывающая промышленность",
    paragraph:
      "Автоматизация технологических процессов, связанных с обработкой добытого сырья",
    color: "rgb(18 34 57)",
    image: darkBlueIcon,
    link: AppRoute.ManufacturingIndustry,
  },
];
const advantages = [
  {
    id: 1,
    image: prodInt,
    title: "Интерфейс оператора",
    paragraph:
      "Управляйте технологическими процессами предприятия",
  },
  {
    id: 2,
    image: admInt,
    title:
      "Интерфейс администратора системы",
    paragraph:
      "Управляйте учетными записями и контролируйте состояние ресурсов сервера",
  },
  {
    id: 3,
    image: developInt,
    title: "Интерфейс разработчика",
    paragraph:
      "Разрабатывайте собственные проекты автоматизации технологического процесса",
  },
];

export function Page() {
  return (
    <Layout>
      <main className="main-page">
        <Intro />
        <Advantages columns={advantages} />

        <AutomationSection
          data={automationColumns}
        />
        <section>
          <div className="container p-0">
            <ExpertAutomatizationAdd

            />
          </div>

        </section>
        <BackgroundSection />
      </main>
    </Layout>
  );
}
//export const doNotPrerender = false;
